import Vue from "vue";
import VueI18n from "vue-i18n";

import greek from "@/plugins/language/gr.js";
import english from "@/plugins/language/en.js";

Vue.use(VueI18n);

const messages = {
	"el-GR": greek[0],
	en: english[0]
};

const i18n = new VueI18n({
	locale: "el-GR", // set locale
	fallbackLocale: "en", // set fallback locale
	messages // set locale messages
});

export default i18n;
